import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { AiAssistantFacadeService } from '../application/ai-assistant-facade.service';
import { AiAssistantDialogComponent } from './ai-assistant-dialog.component';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-ai-assistant-host',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AiAssistantDialogComponent,
  ],
  templateUrl: './ai-assistant-host.component.html',
  styleUrl: './ai-assistant-host.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiAssistantHostComponent {
  readonly aiAssistantFacade = inject(AiAssistantFacadeService);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  // Se recalcule à chaque navigation (login/logout provoquent une navigation)
  private readonly navigationEnd = toSignal(
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)),
    { initialValue: null }
  );

  readonly showLauncher = computed(() => {
    this.navigationEnd();
    return this.authService.isLoggedIn();
  });

  openAssistant(): void {
    if (!this.showLauncher()) {
      return;
    }
    this.aiAssistantFacade.open();
  }
}